import React from 'react';
import {
  Hero,
  Text,
  Container,
  Row,
  Column,
  Space,
  spacing,
} from '@dylanlewis/shared';
import { FormContainer } from '../../Form/FormContainer';
import { bookPurchaseForm } from '../../../common/forms';
import serialize from 'form-serialize';
import { CONTACT } from '../mutations/mutations';
import { Mutation } from 'react-apollo';
import { trackEvent } from '../../../common/analytics';

export class PageBookPurchaseForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      emailHasBeenSent: false,
      emailError: false,
      errors: {},
      deliveryOption: '',
    };
  }

  validateForm(obj) {
    let errors = {};
    let hasErrors = false;

    const requiredFields = ['firstName', 'lastName', 'email', 'phone', 'quantity', 'deliveryOption'];
    requiredFields.forEach(name => {
      if (!obj[name]) {
        errors[name] = 'Required';
      }
    });

    if (obj.email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let isEmail = re.test(String(obj.email).toLowerCase());
      if (!isEmail) {
        errors.email = 'Invalid email address';
      }
    }

    if (obj.quantity && isNaN(Number(obj.quantity))) {
      errors.quantity = 'Please enter a valid number';
    }

    if (obj.deliveryOption === 'courier') {
      ['street', 'suburb', 'city', 'province', 'postalCode'].forEach(name => {
        if (!obj[name]) {
          errors[name] = 'Required for courier delivery';
        }
      });
    }

    if (Object.keys(errors).length) {
      this.setState({ errors: errors });
      hasErrors = true;
    }

    return hasErrors;
  }

  async onSubmit(e, send) {
    e.preventDefault();

    let obj = serialize(e.target, { hash: true });
    const hasErrors = this.validateForm(obj);
    if (hasErrors) return null;

    const fields = {
      formTitle: 'Dylan Lewis Sculpture Garden Book: Order Form',
      firstName: obj.firstName,
      lastName: obj.lastName,
      email: obj.email,
      phone: obj.phone,
      message: obj.comments,
      quantity: Number(obj.quantity),
      deliveryOption: obj.deliveryOption,
      street: obj.street,
      suburb: obj.suburb,
      city: obj.city,
      province: obj.province,
      postalCode: obj.postalCode,
    };

    await send({
      variables: {
        fields,
        enquiry: 'SALES',
        form: 'GARDEN',
        confirmationEmail: true,
      },
    });

    if (e && e.target) e.target.reset();
    return null;
  }

  render() {
    const { page, heroDetails } = this.props;

    return (
      <Container>
        <Hero
          noCrop={heroDetails.noCrop}
          renderVisual={heroDetails.visual}
          subtitle={heroDetails.subtitle}
          title={heroDetails.title}
        >
          {heroDetails.content ? (
            <Text textAlign="center" size="body" as="span" html={heroDetails.content} />
          ) : null
          }
        </Hero>

        <Space bottom size={spacing.space10}>
          <Space padding bottom size={spacing.space5}>
            <Row justifyContent="center">
              <Column width={[1, 8 / 12]} mx="auto" flex="0 0 auto" mb={[4, 0]}>
                <Mutation
                  mutation={CONTACT}
                  onCompleted={response => {
                    if (response.submitForm) {
                      trackEvent('book_purchase', {
                        enquiry_type: 'book_order',
                      });
                      this.setState({ emailHasBeenSent: true });
                    } else {
                      this.setState({ emailHasBeenSent: false });
                    }
                  }}
                  onError={() => this.setState({ emailError: true })}
                >
                  {(send, { loading }) => {
                    const addressFieldNames = ['street', 'suburb', 'city', 'province', 'postalCode'];
                    const fullForm = bookPurchaseForm(this.state.errors).map(f => {
                      if (f.name === 'deliveryOption') {
                        return {
                          ...f,
                          onChange: e => this.setState({ deliveryOption: e.target.value }),
                        };
                      }
                      return f;
                    });
                    const filteredForm =
                      this.state.deliveryOption === 'courier'
                        ? fullForm
                        : fullForm.filter(f => !addressFieldNames.includes(f.name));
                    return (
                      <React.Fragment>
                        <Container>
                          <Row>
                            <Column width={[1, 12 / 12]} mx="auto" flex="0 0 auto" mb={[2, 4]}>
                              {!this.state.emailHasBeenSent ? (
                                <FormContainer
                                  form={filteredForm}
                                  onSubmit={e => this.onSubmit(e, send)}
                                  isLoading={loading}
                                  renderTitle={''}
                                />
                              ) : (
                                <Text>
                                  Thank you for your order enquiry. 
                                  We will reply as soon as possible to confirm payment and delivery details.
                                </Text>
                              )}
                            </Column>
                          </Row>
                        </Container>
                      </React.Fragment>
                    );
                  }}
                </Mutation>
              </Column>
            </Row>
          </Space>
        </Space>
      </Container>
    );
  }
}


